import {useAppSelector} from '../../redux/hooks'
import {appSelector} from '../../redux/slices/appSlices'

function HakAkses() {
  const {selectedMenu, selectedMenuParent} = useAppSelector(appSelector)
  if (selectedMenu?.parent_id == null) return selectedMenuParent
  else return selectedMenu
}

function UserSegment (toCheck: any) {
  let userSegments = localStorage.getItem("user-segment")
  const splitSegments =  (userSegments && userSegments != "null") ? userSegments?.split("|") : []

  return !toCheck || splitSegments.length == 0 || splitSegments.includes(toCheck)
}

function UserProductType (toCheck: any) {
  let UserProductTypes = localStorage.getItem("user-product-type")
  const splitProductTypes =  (UserProductTypes && UserProductTypes != "null") ? UserProductTypes?.split("|") : []

  return !toCheck || splitProductTypes.length == 0 || splitProductTypes.includes(toCheck)
}

export {HakAkses, UserSegment, UserProductType}
